document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.name !== 'properties[Image de référence]') return;
  const file = input.files?.[0];
  input.setCustomValidity('');
  if (!file) return;
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
    input.setCustomValidity('Choisissez une image au format JPG, PNG ou WebP.');
  } else if (file.size > 10 * 1024 * 1024) {
    input.setCustomValidity('Votre image dépasse 10 Mo. Choisissez une image plus légère.');
  }
  if (!input.checkValidity()) input.reportValidity();
});
